<template lang="html">
  <figure
    v-if="ratio"
    class="image"
    :class="ratio ? 'ratio-' + ratio : ''"
    :style="'background-image:url(' + src + ');'"
  ></figure>
  <img v-else class="image" :src="src" />
</template>

<script>
export default {
  props: ['src', 'ratio'],
  computed: {
    theSrc() {
      return this.src;
    },
  },
};
</script>

<style lang="scss">
figure.image {
  max-width: 100%;
  margin: 0;
  background-position: center;
  background-size: cover;
  display: inline-block;

  .ratio-1by1 {
    @include aspect-ratio(1, 1);
  }
  .ratio-1by2 {
    @include aspect-ratio(1, 2);
  }
  .ratio-2by1 {
    @include aspect-ratio(2, 1);
  }
  .ratio-3by2 {
    @include aspect-ratio(3, 2);
  }
  .ratio-4by3 {
    @include aspect-ratio(4, 3);
  }
  .ratio-5by4 {
    @include aspect-ratio(5, 4);
  }
  .ratio-5by3 {
    @include aspect-ratio(5, 3);
  }
  .ratio-5by4 {
    @include aspect-ratio(5, 4);
  }
  .ratio-7by5 {
    @include aspect-ratio(7, 5);
  }
  .ratio-8by3 {
    @include aspect-ratio(8, 3);
  }
  .ratio-8by5 {
    @include aspect-ratio(8, 5);
  }
  .ratio-16by9 {
    @include aspect-ratio(16, 9);
  }
}
img.image {
  max-width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/parts/components/image.vue